import React, { useState, useRef, useEffect } from "react";
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from "reactstrap";
import { Formik, Field, Form } from "formik";
import { useParams } from "react-router";
import * as Yup from "yup";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import FormikInputField from "components/common/Fields/FormikInputField";
import useAxios from "hooks/useAxios";
import Loader from "components/Loader";
import { dateFormate, cellRendererCheck } from "utils/columns";
import Confirm from "components/Confirm";
import plus from "assets/icon/plus-icon.svg";
import { RxComment } from "components/Comments";

const validationSchema = Yup.object({
  comment: Yup.string().required("Comment is required"),
});

let blobFiles = [];

const Comments = (props) => {
  const API = useAxios();
  const { rxNumber, tenantID, hasEditable = true, onClose } = props;

  const { patientId, ceid, gwClaimID } = props.claimData;
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [commentID, setCommentID] = useState(-1);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const patientID = parseInt(patientId);
  const [files, setFiles] = useState([]);
  const formikRef = useRef();
  const [comment, setComment] = useState("");
  const [refetch, setRefetch] = useState(0);
  const [isDeletedFileIds, setIsDeletedFileIds] = useState([]);
  const [valid, setValid] = useState(false);

  const [initialValues, setInitialValues] = useState({
    comment: "",
    files: [],
  });
  
  const addComment = async (payload, actions) => {
    try {
      const url = `/${tenantID}/Comments/AddRxComment`;
      const formData = new FormData();

      formData.append("commentId", commentID);
      formData.append("claimId", gwClaimID);
      formData.append("comment", payload.comment);

      // Append deleted fileRepositoryIDs
      isDeletedFileIds.forEach(id => {
        formData.append("fileRepositoryIDs", id);
      });

      // Extract files from payload (keys that start with 'file')
      Object.keys(payload).forEach((key) => {
        if (key.startsWith("file") && payload[key] instanceof File) {
          formData.append("files", payload[key]);
        }
      });

      const data = await API.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        hideLoader: true,
      });

      if (data.status === 200) {
        setFiles([]);
        blobFiles = [];
        toast.success("Comment added successfully!");
        setValid(false);
        actions.resetForm();
        setSubmitting(false);
        setCommentID(-1);
        // onClose();
        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        setInitialValues({
          comment: "",
          files: [],
        });
        setRefetch(rand);
      } else {
        setSubmitting(false);
        setFiles([]);
        blobFiles = [];
      }
    } catch (error) {
      console.log(error, "error");
      setSubmitting(false);
    }
  };

  const handleDeleteConfirmation = async (row) => {
    setDeleteConfirm(!isDeleteConfirm);
    if (row) setCommentID(row.commentID);
  };

  // const deleteRow = async () => {
  //   handleDeleteConfirmation();

  //   let result = await API.post(`/${tenantID}/Comments/inactivecomment/${coveredEntityID}/${commentID}`, null, {
  //     hideLoader: true,
  //   });
  //   if (result) {
  //     toast.success("Item removed successfully");
  //     fetchPatientComments();
  //   }
  // }

  const handleSubmit = async (values, actions) => {
    const { comment } = values;
    const { setErrors } = formikRef.current;
    if (!comment.trim()) return setErrors({ comment: "Enter valid comment" });
    const fileObject = {};
    files.map((f, i) => {
      fileObject["file" + (i + 1)] = f;
      return f;
    });
    setSubmitting(true);
    addComment({ comment, ...fileObject }, actions);
  };

  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  const handleFiles = (f) => {
    setFiles([...files, ...f]);
    let comments = {};
    comments.files = [...files, ...f];
    let spData = { ...initialValues, ...comments };
    setInitialValues(spData);
  };

  const onHandleFileChange = (e) => {
    const files = e;
    const validfiles = files.filter(file=>file.size<=MaxSize);
    const invalidfiles = files.filter(file => file.size > MaxSize);
    if (invalidfiles.length > 0) {
      setValid(true);
    } else {
      setValid(false);
    }
    handleFiles(validfiles);
    validfiles.forEach((data) => {
      fileToDataUri(data).then((dataUri) => {
        blobFiles.push(dataUri);
      });
    });
  };

  const onCommentEdit = (row) => {
    if (row) {
      let comments = {};
      comments.comment = row.comments;
      setComment(row.comments);
      setCommentID(row.commentID);
      const files = row.files;
      //onHandleFileChange(files);
      handleFiles(files);
      let spData = { ...initialValues, ...comments };
      setInitialValues(spData);
      setIsDeletedFileIds([]);
    }
  };

  const handleComment = ({ target: { value } }) => {
    setComment(value);
    let comments = {};
    comments.comment = value;
    let spData = { ...initialValues, ...comments };
    setInitialValues(spData);
  };
  const MaxSize = 5242880;

  const ErrorMessage = ({ children }) => (
    <div
      style={{
        fontStyle: "italic",
        color: "red",
      }}
    >
      {children}
    </div>
  );

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) => {
      const fileToRemove = prevFiles[indexToRemove];
      const updatedFiles = prevFiles.filter((_, index) => index !== indexToRemove);
  
      if (fileToRemove?.fileRepositoryID) {
        setIsDeletedFileIds(prevIds => [...prevIds, fileToRemove.fileRepositoryID]);
      }
      return updatedFiles;
    });
  };

  return (
    <>
      {hasEditable && (
        <Card className="border-0 shadow-top">
          {submitting && <Loader opacity={0.01} color="black" />}
          <CardBody>
            <Formik
              // initialValues={{
              //   comment: '',
              //   files: [],
              // }}
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              innerRef={formikRef}
              children={(props) => {
                return (
                  <Form>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <Field
                            id="Comment"
                            name="comment"
                            type="textarea"
                            maxlength="250"
                            component={FormikInputField}
                            onKeyUp={handleComment}
                            label="Add Comment"
                            placeholder="Comment"
                            value={comment}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup>
                          <Label>Attachment</Label>
                          <Dropzone onDrop={onHandleFileChange}>
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                            }) => (
                              <section
                                className={`drop-zone ${
                                  isDragActive ? "active" : ""
                                }`}
                              >
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <div className="browse">
                                    <span>Drag and drop attachment or</span>
                                    <span className="highlight font-weight-600">
                                      Browse
                                    </span>
                                  </div>
                                </div>
                              </section>
                            )}
                          </Dropzone>
                          {/* Error: Too many files */}
                          {files.length > 4 && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                              You can upload a maximum of 4 files.
                            </div>
                          )}
                          {/* Error: File size too large */}
                          {valid && (
                            <ErrorMessage>
                              File attached should not be greater than 5MB
                            </ErrorMessage>
                          )}
                          {/* File list display */}
                          {files?.length > 0 && (
                            <div>
                              {files.map((item, index) => {
                                const fileName = item.name || item.fileName;
                                const isLong = fileName.length > 43;
                                const displayName = isLong ? `${fileName.substring(0, 43)}...` : fileName;
                                return (
                                  <div
                                    key={fileName}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      marginBottom: "8px",
                                      maxWidth: "100%", 
                                    }}
                                  >
                                    <div
                                     {...(isLong ? { title: fileName } : {})}
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "calc(100% - 30px)",
                                      }}
                                    >
                                      {displayName}
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveFile(index)}
                                      style={{
                                        marginLeft: "10px",
                                        background: "transparent",
                                        border: "none",
                                        color: "red",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        flexShrink: 0,
                                      }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end align-items-center">
                      <div>
                        <Button
                          color="primary"
                          className="reset addbtn"
                          type="submit"
                          size="sm"
                          disabled={submitting || files.length >=5}
                        >
                          <span className="right_5">
                            {" "}
                            <img src={plus} alt="" />
                          </span>{" "}
                          Add
                        </Button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            ></Formik>
            {/* <Confirm
              isOpen={isDeleteConfirm}
              loading={loading}
              message='Are you sure you want to delete this comment?'
              onToggle={handleDeleteConfirmation}
              onCancel={handleDeleteConfirmation}
              onContinue={deleteRow}
            /> */}
          </CardBody>
        </Card>
      )}
      <Card className="border-0 rounded-bottom-1 mt-3 table-card">
        <CardBody>
          <RxComment
            // rxNumber={rxNumber}
            // patientID={patientID}
            tenantID={tenantID}
            claimID={gwClaimID}
            text="Comments"
            onCommentEdit={onCommentEdit}
            // handleDeleteConfirmation={handleDeleteConfirmation}
            refetch={refetch}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default Comments;
